<template>
  <div
    class="landingLeftRightContentSection"
    :class="{
      'landingLeftRightContentSection--border': data.AddBorder,
      'landingLeftRightContentSection--purple': data.PurpleBg,
    }"
  >
    <div class="container">
      <div class="landingLeftRightContentSection__content">
        <div class="landingLeftRightContentSection__contentLeft">
          <div class="landingLeftRightContentSection__contentLeftContent">
            <div v-if="data.SmallTitle" class="landingLeftRightContentSection__small">
              {{ data.SmallTitle }}
            </div>
            <div
              v-if="data.Description"
              class="landingLeftRightContentSection__text"
              v-html="data.Description"
            />
            <div v-if="data.Button" class="landingLeftRightContentSection__button">
              <VButton
                v-if="data.Button.Url && data.Button.LinkText"
                :text="data.Button.LinkText"
                :href="data.Button.Url"
                :theme="data.PurpleBg ? 'orange' : 'purple'"
              />
            </div>
          </div>
        </div>
        <div v-if="data.Background" class="landingLeftRightContentSection__contentRight">
          <div class="landingLeftRightContentSection__contentImage">
            <new-image-box
              :alt="data.SmallTitle ? data.SmallTitle : ''"
              :src="JSON.parse(data.Background).url"
              :width="810"
              :height="650"
              fit
              image-params="w_810,h_650,crop"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VButton from '@/components/VButton.vue';
import NewImageBox from '@/components/NewImageBox.vue';

export default {
  name: 'LandingLeftRightContentSection',
  components: { NewImageBox, VButton },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style scoped lang="scss">
.landingLeftRightContentSection {
  $root: &;
  background: $cWhite;
  padding: 6.4rem 0 2rem;

  @include rwd('small-tablet') {
    padding: 5.6rem 0 2rem;
  }

  &__contentLeft {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0 0 55.5%;
    max-width: 55.5%;
    padding: 4rem 5rem 4rem 0;

    @include rwd('large-tablet') {
      padding: 4rem 2rem 4rem 0;
    }

    @include rwd('tablet') {
      flex: 0 0 100%;
      max-width: 100%;
      padding: 4rem 0 4rem 0;
    }
  }

  &__contentRight {
    flex: 0 0 44.5%;
    max-width: 44.5%;
    height: auto;

    @include rwd('tablet') {
      display: none;
    }
  }

  &__contentImage {
    position: relative;
    aspect-ratio: 620 / 460;

    ::v-deep .newImage {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__text {
    max-width: 60rem;

    ::v-deep a {
      color: $cSec;
      text-decoration: underline;
    }
  }

  &__content {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 4rem;
  }

  &__button {
    margin-top: 3rem;
  }

  &__small {
    font-size: 1.8rem;
    line-height: 1.5;
    color: $cAddDark02;
    font-weight: 500;
    margin-bottom: 1rem;
  }

  ::v-deep p,
  ::v-deep li {
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-weight: 500;
    color: $cAddDark02;

    b,
    strong {
      font-weight: 700;
    }
  }

  ::v-deep p {
    margin-bottom: 2rem;
  }

  ::v-deep li {
    position: relative;
    margin-bottom: 1.4rem;
    padding-left: 3rem;

    &:after {
      @include icomoon('circle-fill-check');
      position: absolute;
      left: 0;
      top: 0;
      color: $cSec;
    }
    &:before {
      content: '';
      width: 1rem;
      height: 1rem;
      background: $cWhite;
      position: absolute;
      border-radius: 50%;
      left: 0.3rem;
      top: 0.6rem;
      color: $cSec;
    }
  }

  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3,
  ::v-deep h4,
  ::v-deep h5 {
    font-size: 4rem;
    line-height: 1.15;
    font-weight: 600;
    max-width: 50rem;
    margin-bottom: 2rem;

    b,
    strong {
      color: $cSec;
      font-weight: 600;
    }

    @include rwd('large-tablet') {
      font-size: 4rem;
    }

    @include rwd('tablet') {
      max-width: 100%;
    }

    @include rwd('small-tablet') {
      font-size: 2.8rem;
    }
  }

  &__contentRight {
    border-radius: 5px;
    overflow: hidden;
  }

  &--border {
    #{$root}__content {
      border: 1px solid $cAddLight;
      padding: 1rem 1rem 1rem 0;
      border-radius: 3px;
    }

    #{$root}__contentLeft {
      padding: 4rem;

      @include rwd('large-tablet') {
        padding: 4rem 2rem;
      }

      @include rwd('tablet') {
        padding: 4rem 0;
      }
    }
  }

  &--purple {
    #{$root}__content {
      background: $cMain;
      color: $cWhite;
      border: none;
      padding: 0;
      align-items: unset;
      border-bottom: 0;
    }

    #{$root}__contentLeft {
      flex: 0 0 42%;
      max-width: 42%;
      padding: 4rem 5rem;

      @include rwd('large-tablet') {
        padding: 4rem 2rem;
      }

      @include rwd('tablet') {
        padding: 4rem 2rem;
        flex: 0 0 100%;
        max-width: 100%;
      }
    }

    #{$root}__contentRight {
      flex: 0 0 58%;
      max-width: 58%;
      border-radius: 0;
      min-height: 65rem;
    }

    #{$root}__contentImage {
      aspect-ratio: unset;
      height: 100%;
      width: 100%;
    }

    #{$root}__small {
      color: $cWhite;
    }

    ::v-deep p,
    ::v-deep li {
      color: $cWhite;
    }
  }
}
</style>
